import React from 'react';
import './AvisoFinalEn.css';

function AvisoFinalEn() {
  return (
    <div className="aviso-final-en">
      <strong>Do not self-medicate.</strong>
      <span> Seek guidance from a healthcare professional.</span>
    </div>
  );
}

export default AvisoFinalEn;